var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.buttonShow,
              expression: "buttonShow"
            }
          ],
          staticClass: "section operations"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.cooperateEdit,
                  expression: "cooperateEdit"
                }
              ],
              staticClass: "triggers"
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "Refresh", type: "primary" },
                      on: { click: _vm.toQuery }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Refresh")))]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px",
                        "margin-right": "5px"
                      },
                      attrs: {
                        action: _vm.URL.common.uploadStorage,
                        headers: { sessionId: _vm.user.sessionId },
                        "show-file-list": false,
                        data: _vm.uploadParams,
                        "on-success": _vm.uploadEnd
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { no: "fileUpload", type: "primary" } },
                        [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "fileDelete", type: "danger" },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("FileHistory.Delete")))]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { height: "400px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", flex: "1" },
            attrs: {
              "config-module": "136235",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "check-sub-record": false
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("pre-view-file-dialog", {
        attrs: {
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }